/**
 * Stores the resolved URL (currentSrc) for each asset's rendered gallery thumbnail.
 * Populated when a gallery card image loads so the drag ghost can reuse the exact
 * same URL the browser already has decoded in memory — no re-fetch, no flash.
 */
const DRAG_PREVIEW_SRC_CACHE = new Map<string, string>();

export const cacheDragPreviewSrc = (clipId: string, src: string): void => {
  DRAG_PREVIEW_SRC_CACHE.set(clipId, src);
};

export const getDragPreviewSrc = (clipId: string): string | undefined => DRAG_PREVIEW_SRC_CACHE.get(clipId);
